
import Vue from 'vue';
import { DEFAULT_DATE_FORMAT, DEFAULT_DATE_TIME_FORMAT } from '../config/constant.js';

Vue.filter('commonDateFormat', function (value, format = DEFAULT_DATE_FORMAT ) {
        if (!value) return value;
        const date = Vue.prototype.$moment.parseZone(value,true).tz('utc', true)

        return date.isValid() ? date.format(format) :  value
});

Vue.filter('toDateTimeString', function(value, format = DEFAULT_DATE_TIME_FORMAT){
      if (!value) return value;

      const date = Vue.prototype.$moment(value)

      return date.isValid() ? date.format(format) :  value
})

Vue.filter('removeTrailingZeros', function (value) {
      if (typeof value === 'number') {
        value = value.toFixed(10);
      } else if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!isNaN(parsedValue)) {
          value = parsedValue.toFixed(10);
        }
      }

      return value.replace(/\.?0*$/, '');
    });
